module.exports = __webpack_public_path__ + "img/bgtop-prod.7929bb55.jpg";